import React from 'react';

import ChannelsListItem from './channel';

import {
    Wrapper,
    Header,
    PackageInfo,
    BaseInfo,
    LogoWrapper,
    Logo,
    Title,
    Subtitle,
    ChannelsList,
    Body,
    Button,
    StyledRadioButton,
} from './styled';

export default class packageChannels extends React.Component {
    static defaultProps = {
        items: () => [],
        color: null,
        title: '',
        logoNoBackground: null,
        id: -1,
        baseCost: 0,
        costRa: () => [],
    }

    state = {
        cost: this.props.baseCost,
        duration: 0,
        promoCost: [],
    }

    componentDidMount() {
        this.setRa();
    }

    onRadioChange = (cost, duration) => {
        this.setState({ cost, duration });
    }

    onButtonClick = () => {
        this.props.onButtonClick(this.props.id, this.state.cost, this.state.duration);
    }

    setRa = () => {
        const costRaExist = this.props.costRa.length > 0;
        if (!costRaExist) {
            const cards = [];
            cards.push({ duration: 3, raID: Math.random() * 1000 }, { duration: 6, raID: Math.random() * 1000 });
            this.setState({
                promoCost: cards,
            });
        } else {
            this.setState({ promoCost: this.props.costRa });
        }
    }

    setPrice = (cost) => {
        if (cost) {
 return ` — ${cost} ₽/мес`;
}
        return '';
    }

    checkCost = () => {
        return !(this.props.costRa.length > 0);
    }

    render() {
        const { id, items, color, title, logoNoBackground, subtitle, baseCost } = this.props;
        const { cost, promoCost } = this.state;
        return (
            <Wrapper>
                <Header background={color}>
                    <PackageInfo>
                        <BaseInfo>
                            <Title>{title}</Title>
                            <Subtitle>{subtitle}</Subtitle>
                        </BaseInfo>
                        <LogoWrapper>
                            <Logo src={logoNoBackground} alt={title}></Logo>
                        </LogoWrapper>
                    </PackageInfo>
                    <ChannelsList>
                        {
                            [...items].splice(0, 12).map(item => <ChannelsListItem item={item} key={item.chid} />)
                        }
                    </ChannelsList>
                </Header>
                <Body>
                    <StyledRadioButton checked={cost === baseCost} onChange={() => this.onRadioChange(baseCost, -1)} name={`channelPacket_${id}`} value={baseCost} label={`Базовая цена — ${baseCost} ₽/мес`} />
                    {
                        promoCost.map((element, index) =>
                            <StyledRadioButton key={index}
                                onChange={() => this.onRadioChange(element.cost, element.duration)}
                                name={`channelPacket_${id}`}
                                checked={cost === element.cost}
                                value={element.cost}
                                disabled={this.checkCost()}
                                label={`Подписка на ${element.duration} мес.${this.setPrice(element.cost)}`} />)
                    }
                    <Button type={'secondary'} text={'Подключить'} onClick={this.onButtonClick} />
                </Body>
            </Wrapper>
        );
    }
}
